module.exports = __webpack_public_path__ + "images/sprites/ui/btn_cv_bu_bold_75e447d2385dcce81943e518db8cc754.png";